import { PayloadAction } from '@reduxjs/toolkit';

import { ActionTypes } from './globalConfigConfig';
import { GlobalConfigState } from './globalConfigInterface';

const initialState: GlobalConfigState = {
    baseUrl: {
        url: 'http://localhost:40001',
        protocol: 'http',
        port: '4001',
        host: 'localhost',
        isTestingEndpoint: true
    },
    isSpinnerVisible: false
};
const reducer = (state: GlobalConfigState, action: PayloadAction<any>): GlobalConfigState => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.UPDATE_BASE_URL:
            return {
                ...state,
                error: undefined,
                baseUrl: payload
            };
        case ActionTypes.CLEAR_API_ERROR:
            return {
                ...state,
                error: undefined
            };
        case ActionTypes.UPDATE_API_ERROR:
            return {
                ...state,
                error: payload
            };
        case ActionTypes.SET_SPINNER_VISIBILITY:
            return {
                ...state,
                isSpinnerVisible: !!payload
            };
        case ActionTypes.UPDATE_SESSION_AUTH:
            return {
                ...state,
                auth: payload
            };
        case ActionTypes.UPDATE_TENANT_ID:
            return {
                ...state,
                authInfo: {
                    serverId: payload?.serverId || state.authInfo?.serverId,
                    tenantId: payload?.tenantId || state.authInfo?.tenantId
                }
            };
        default:
            return { ...initialState, ...state };
    }
};

export default reducer;
